export default [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/modules/public-app/pages/HomePage.vue"),
    meta: {
      breadcrumb: [{label: "Dashboard"}],
      requireLogin: true,
      layout: 'App',
      module: 'Dashboard'
    },
  },

  {
    path: "/profile/",
    name: "ProfilePage",
    component: () => import("@/modules/public-app/pages/user/Profile.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}],
      requireLogin: true,
      layout: 'App',
      module: 'CitizenProfile',
      requiredRight: 'view'
    }
  },

  {
    path: "/profile/preferences",
    name: "ProfilePreferencesPage",
    component: () => import("@/modules/public-app/pages/user/ProfilePreferences.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}, {label: "Preferences"}],
      requireLogin: true,
      layout: 'App',
      module: 'CitizenProfilePreferences',
      requiredRight: 'view'
    }
  },

  {
    path: "/profile/billing",
    name: "ProfileBillingPage",
    component: () => import("@/modules/public-app/pages/user/ProfileBilling.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}, {label: "Billing"}],
      requireLogin: true,
      layout: 'App',
      module: 'CitizenProfileBilling',
      requiredRight: 'view'
    }
  },

  {
    path: "/login/",
    name: "Login",
    component: () => import("@/modules/public-app/pages/user/Login.vue"),
    meta: {
      breadcrumb: [{label: "Login"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/create-account/",
    name: "Register",
    component: () => import("@/modules/public-app/pages/user/Register.vue"),
    meta: {
      breadcrumb: [{label: "Create account"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/recover-password/",
    name: "RecoverPassword",
    component: () => import("@/modules/public-app/pages/user/RecoverPassword.vue"),
    meta: {
      breadcrumb: [{label: "Recover password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/reset-password/",
    name: "ResetPassword",
    component: () => import("@/modules/public-app/pages/user/ResetPassword.vue"),
    meta: {
      breadcrumb: [{label: "Reset password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/map/",
    name: "MapPage",
    component: () => import("@/pages/MapPage.vue"),
    meta: {
      breadcrumb: [{label: "Map"}],
      requireLogin: true,
      layout: 'App',
      module: 'map',
      hideBreadcrumb: true,
      fullWidth: true
    },
  },

  {
    path: "/page/:formId/:slug?",
    name: "FormRender",
    component: () => import("@/pages/documents/FormRenderPage.vue"),
    meta: {
      breadcrumb: [{label: "Form Page"}],
      requireLogin: false,
      layout: 'App'
    }
  },

  {
    path: "/embed/:apiKeyAlias?",
    name: "Embed",
    component: () => import("@/pages/EmbedPage.vue"),
    meta: {
      requireLogin: false,
      layout: 'App',
      module: 'layer',
      requiredRight: 'view',
      hideBreadcrumb: true,
      fullWidth: true
    },
  },

  {
    path: "/projects/",
    name: "ProjectsPage",
    component: () => import("@/modules/public-app/pages/ProjectsPage.vue"),
    meta: {
      breadcrumb: [{label: "My projects"}],
      requireLogin: true,
      layout: 'App',
      module: 'PublicProjects',
      requiredRight: 'view'
    }
  },

  {
    path: "/data-sources/",
    name: "LayersPage",
    component: () => import("@/modules/public-app/pages/LayersPage.vue"),
    meta: {
      breadcrumb: [{label: "Data sources"}],
      requireLogin: true,
      layout: 'App',
      module: 'PublicLayers',
      requiredRight: 'view'
    }
  },

  {
    path: "/plans/",
    name: "SubscriptionPlansPage",
    component: () => import("@/modules/public-app/pages/SubscriptionPlansPage.vue"),
    meta: {
      breadcrumb: [{label: "Subscription plans"}],
      requireLogin: true,
      layout: 'App',
      module: 'PublicSubscriptionPlans',
      requiredRight: 'view'
    }
  },

  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/layout/NotFound.vue"),
    meta: {
      requireLogin: false,
      layout: 'NotFound'
    },
  },

]
